// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".survey-screen[data-v-94669664]{padding:10px 0;text-align:center}@media(max-width:600px){.survey-screen[data-v-94669664]{padding:50px 0}}.prompt[data-v-94669664]{color:#313b59;font-size:16px;font-weight:700;margin-bottom:20px}.btn[data-v-94669664]{display:inline-block;height:36px;margin:12px 10px 0;width:174px}", ""]);
// Exports
module.exports = exports;
